
import { LocalStorageService } from '../services/local-storage.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'payment-success',
  templateUrl: './payment-success.component.html',
})
export class PaymentSuccessComponent implements OnInit {

  public loading = true;

  constructor(
    private localStorageService: LocalStorageService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.localStorageService.remove('payUURL');
    this.localStorageService.remove('accessToken');
    this.localStorageService.remove('proformaNumber');

    this.route.queryParams.subscribe(params => {
      if (params['error'] !== undefined) {
        this.router.navigateByUrl('/payments/failure');
        return;
      }
      this.loading = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/payments/payment-success.component.ts